import styled from "styled-components";

export const Container = styled.div`
  display: inline-block;
`;

export const TooltipStyled = styled.div`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color};
  width: ${({ width }) => width};
  opacity: 0.9;
  max-width: 350px;
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
  border-radius: 3px;
  line-height: 17px;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  box-shadow: 0px 2px 4px 0px #00000029;
`;
